<template>
    <SupplierFollowUp></SupplierFollowUp>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SupplierFollowUp = defineAsyncComponent(() =>
    import("../../components/Purchasing/SupplierFollowUp.vue")
);

export default {
    name: "SupplierFollowUp_Purchashing",
    components: { SupplierFollowUp, AuthLayout },
};
</script>
